import { AddIcon, SubtractIcon } from "../../../assets"
import styles from "./style.module.css"

export const QuantityModifier = () =>
{
    return (
        <div className={styles.container}>
                                    

         <div className={styles.rectangle}>
           <div className={styles.part}>
            <AddIcon/>
           </div>
           <div className={styles.part}>
            1
           </div>
           <div className={styles.part}>
            <SubtractIcon />
           </div>
         </div>
        </div>
    )
}